import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="ElevenLabs voice generation" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">ElevenLabs Voice</h2>

        <div className="mt-8">
          <div className="space-y-2">
            <p>• AI voice generation</p>
            <p>• Voice cloning</p>
            <p>• Real-time synthesis</p>
            <p>• Conversational AI integration</p>
          </div>
        </div>
      </div>
    </Slide>
  );
};
